import type { SVGProps } from 'react';

interface UserIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function UserIcon({ className, ...props }: UserIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="4.75 4.75 14.5 14.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M8.88867 13.5273H15.1113C15.9437 13.5274 16.7424 13.8587 17.3311 14.4473C17.9195 15.0359 18.25 15.8346 18.25 16.667C18.2499 17.0868 18.083 17.4893 17.7861 17.7861C17.4893 18.083 17.0868 18.2499 16.667 18.25H7.33301C6.9132 18.2499 6.51072 18.083 6.21387 17.7861C5.91701 17.4893 5.75009 17.0868 5.75 16.667C5.75 15.8346 6.08046 15.0359 6.66895 14.4473C7.25755 13.8587 8.05627 13.5274 8.88867 13.5273ZM12 5.75C12.6262 5.75 13.2271 5.99861 13.6699 6.44141C14.1126 6.88419 14.3613 7.48517 14.3613 8.11133C14.3613 8.73728 14.1124 9.33757 13.6699 9.78027C13.2271 10.2231 12.6262 10.4727 12 10.4727C11.3738 10.4727 10.7729 10.2231 10.3301 9.78027C9.88757 9.33757 9.63873 8.73728 9.63867 8.11133C9.63867 7.48517 9.88735 6.88419 10.3301 6.44141C10.7175 6.05397 11.2261 5.8154 11.7666 5.76172L12 5.75Z" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  );
}
